import authApi from 'api/auth';
import { useAppDispatch, useAppSelector, useAppTranslation } from 'app/hooks';
import promo_code_icon from 'assets/icons/promo_code_icon.png';
import promo_code_icon_dark from 'assets/icons/promo_code_icon_dark.png';
import ConditionButton from 'components/Commons/ConditionButton';
import Typo from 'consts/typography';
import { useHandleResponseError } from 'hooks/useHandleResponseError';
import useThemes from 'hooks/useThemes';
import useUserDetail from 'hooks/useUserDetail';
import React, { useState } from 'react';
import { CgLogIn } from 'react-icons/cg';
import { FaRegUserCircle } from 'react-icons/fa';
import { LuLogOut } from 'react-icons/lu';
import { MdEvent } from 'react-icons/md';
import { TbFileDescription } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';
import { getLocalStorage, removeLocalStorage, setLocalStorage } from 'utils/sessionStorage';
import {
  onChangeAuthPage,
  selectCurrentConverter,
  selectEvent,
  selectIsShowSubMenu,
  setBlance,
  setCurrentConverter,
  setIsShowTransactionModal,
  setShowBetForm,
  setShowEventNoti,
  setShowSubMenu,
} from '../../homeSlice';
import PromotionModal from '../Modals/PromotionModal';
import UserBankbookModal from '../Modals/UserBankbookModal';
import UserProfileModal from '../Modals/UserProfileModal';
import WalletConnectModal from '../Modals/WalletConnectModal';

interface SubFooterMenuProps {
  onShowChangePasswordPage: () => void;
}

const SubFooterMenu: React.FunctionComponent<SubFooterMenuProps> = ({
  onShowChangePasswordPage,
}) => {
  const { currentTheme } = useThemes();
  const [isOpenPromotionModal, setIsOpenPromotionModal] = useState<boolean>(false);
  const [isOpenEventModal, setIsOpenEventModal] = useState<boolean>(false);
  const [isOpenReferralCodeModal, setIsOpenReferralCodeModal] = useState<boolean>(false);
  const [isOpenProfileModal, setIsOpenProfileModal] = useState<boolean>(false);
  const [isOpenUserBankbookModal, setIsOpenUserBankbookModal] = useState<boolean>(false);
  const [isOpenWalletConnectModal, setIsOpenWalletConnectModal] = useState<boolean>(false);
  const isShowSubMenu = useAppSelector(selectIsShowSubMenu);
  const currentConverter = useAppSelector(selectCurrentConverter);
  const { isUserLoggedIn, getUserDetail } = useUserDetail();
  const accessToken = getLocalStorage('access_token_terabet');
  const handleResponseError = useHandleResponseError();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const eventSelected = useAppSelector(selectEvent);

  const t = useAppTranslation();
  const handleLogout = async () => {
    const { ok, error } = await authApi.logout({
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    if (ok) {
      navigate('/');
    }

    if (error) {
      handleResponseError(error);
    }

    removeLocalStorage('access_token_terabet');
    dispatch(setShowSubMenu(false));
    dispatch(setShowBetForm(false));
    dispatch(setBlance('0'));
    getUserDetail();
  };

  const changeConverter = (checked: boolean) => {
    if (checked) {
      dispatch(setCurrentConverter('decimal'));
      setLocalStorage('converter', 'decimal');
    } else {
      dispatch(setCurrentConverter('american'));
      setLocalStorage('converter', 'american');
    }
  };

  const handleUserBankbookClick = () => {
    setIsOpenUserBankbookModal((prev) => !prev);
  };

  const handlePromotionClick = () => {
    setIsOpenPromotionModal((prev) => !prev);
  };

  const handleEventClick = () => {
    setIsOpenEventModal((prev) => !prev);
  };

  const onShowLoginPage = () => {
    dispatch(onChangeAuthPage(0));
  };

  const onShowSignUpPage = () => {
    dispatch(onChangeAuthPage(1));
  };

  const handleReferralCodeClick = () => {
    setIsOpenReferralCodeModal((prev) => !prev);
  };

  const handleTransactionHistoryClick = () => {
    dispatch(setIsShowTransactionModal(true));
  };

  const handleUserProfileClick = () => {
    setIsOpenProfileModal((prev) => !prev);
  };

  const handleWalletConnectClick = () => {
    setIsOpenWalletConnectModal((prev) => !prev);
  };
  const handleStreamingClick = () => {
    navigate('/streaming');
  };

  const handleShowEventNoti = () => {
    dispatch(setShowEventNoti(true));
  };

  return (
    <div
      className={`sub-footer-menu flex-row items-center justify-center primary-text-color ${
        isShowSubMenu ? 'sub-footer-menu__show' : 'sub-footer-menu__hide'
      }`}
    >
      <div className="sub-menu items-center justify-around">
        <div className="toggle-converter">
          {/* <Switch
            className="odd-format-switch"
            checkedChildren="Decimal"
            unCheckedChildren="American"
            checked={currentConverter === 'decimal'}
            onChange={changeConverter}
          /> */}
        </div>
        <button
          className="flex-col items-center menu-item gap-1"
          type="button"
          onClick={handleShowEventNoti}
        >
          <MdEvent className="w-5 h-5" />
          <span>{t('header.event')}</span>
        </button>
        {!isUserLoggedIn ? (
          <>
            <button
              className="flex-col items-center menu-item gap-1"
              type="button"
              onClick={onShowLoginPage}
            >
              <CgLogIn className="w-5 h-5" />
              <span>{t('header.login')}</span>
            </button>
            <button
              className="flex-col items-center menu-item gap-1"
              type="button"
              onClick={onShowSignUpPage}
            >
              <TbFileDescription className="w-5 h-5 primary-text-color" />
              <span id="register-btn">{t('header.register')}</span>
            </button>
          </>
        ) : (
          <>
            <button
              className="flex-col items-center menu-item gap-1"
              type="button"
              onClick={handleUserProfileClick}
            >
              <FaRegUserCircle className="w-5 h-5 primary-text-color" />
              <span id="profile-btn">{t('accountSubMenu.userProfile')}</span>
            </button>
            {/* <ConditionButton
              onClick={handleWalletConnectClick}
              className="flex-col items-center menu-item gap-1"
              content={
                <>
                  <FaWallet className="w-5 h-5" />
                  <span>{t('common.walletConnect')}</span>
                </>
              }
            /> */}
            {/* <ConditionButton
              onClick={handleUserBankbookClick}
              className="flex-col items-center menu-item gap-1"
              content={
                <>
                  <img src={bankbook} width={20} height={20} alt="transaction history icon" />
                  <span>{t('accountSubMenu.bankbook')}</span>
                </>
              }
            /> */}
            {/* <ConditionButton
              onClick={handleTransactionHistoryClick}
              className="flex-col items-center menu-item gap-1"
              content={
                <>
                  <img
                    src={currentTheme === 'dark' ? transaction_history : transaction_history_dark}
                    width={20}
                    height={20}
                    alt="transaction history icon"
                  />
                  <span>{t('accountSubMenu.transactionHistory')}</span>
                </>
              }
            /> */}
            <ConditionButton
              className="flex-col items-center menu-item gap-1"
              content={
                <>
                  <img
                    src={currentTheme === 'dark' ? promo_code_icon : promo_code_icon_dark}
                    width={20}
                    height={20}
                    alt="promo_code"
                  />
                  <span>{t('promotion.title')}</span>
                </>
              }
              onClick={handlePromotionClick}
              isSkipCheckOnClick={true}
            />
            {/* <ConditionButton
              className="flex-col items-center menu-item gap-1"
              content={
                <>
                  <img
                    src={currentTheme === 'dark' ? event_icon : event_icon_dark}
                    width={20}
                    height={20}
                    alt="event"
                  />
                  <span>{t('event.title')}</span>
                </>
              }
              onClick={handleEventClick}
            /> */}
            <PromotionModal
              title={t('promotion.title')}
              visible={isOpenPromotionModal}
              closeModal={handlePromotionClick}
              className="common-modal withdraw-modal"
            />
            {/* <EventModal
              title={t('event.title')}
              visible={isOpenEventModal}
              closeModal={handleEventClick}
              className="common-modal withdraw-modal"
            /> */}
            <button
              className="flex-col items-center menu-item gap-1"
              type="button"
              onClick={handleLogout}
            >
              <LuLogOut className="w-5 h-5" />
              <span>{t('accountSubMenu.logout')}</span>
            </button>
          </>
        )}
        <i className={`${Typo.p8}`}>Version 1.0</i>
        <UserProfileModal
          title={t('userProfile.title')}
          visible={isOpenProfileModal}
          closeModal={handleUserProfileClick}
          onShowChangePasswordPage={onShowChangePasswordPage}
        />
        <UserBankbookModal
          title={t('accountSubMenu.bankbook')}
          visible={isOpenUserBankbookModal}
          closeModal={handleUserBankbookClick}
          className="common-modal withdraw-modal"
        />
        <WalletConnectModal isOpen={isOpenWalletConnectModal} onCancel={handleWalletConnectClick} />
      </div>
    </div>
  );
};

export default SubFooterMenu;
